// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__22JmN","vLegacy":"SelectSecondary_vLegacy__2oHlO","error":"SelectSecondary_error__3NzOg","disabled":"SelectSecondary_disabled__3swMs"};